import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import type { GlobalConfigPayload } from '../types'
import type { EmbedEditorPresetType } from '../types/preset'
import { getEmbedEditorPreset } from '../presets'

export const useGlobalConfig = defineStore('integrationEmbedGlobalConfig', () => {
  const globalConfig = ref<{
    isShowFrame: boolean
    isShowDemo: boolean
    timeoutDuration: number
  }>({
    isShowFrame: true,
    isShowDemo: false,
    timeoutDuration: 180000,
  })

  const embedEditorPresetType = ref<EmbedEditorPresetType>('default')
  const embedEditorPreset = computed(() => getEmbedEditorPreset(embedEditorPresetType.value))

  const setEmbedEditorPreset = (type: EmbedEditorPresetType) => {
    embedEditorPresetType.value = type
  }

  const applyConfig = (config: GlobalConfigPayload) => {
    if (config?.mode) {
      setEmbedEditorPreset(config.mode)
    }
    if (typeof config?.isShowFrame !== 'undefined') {
      globalConfig.value.isShowFrame = Boolean(config.isShowFrame)
    }
    if (typeof config?.isShowDemo !== 'undefined') {
      globalConfig.value.isShowDemo = Boolean(config.isShowDemo)
    }
    if (typeof config?.timeoutDuration !== 'undefined') {
      const duration = Number(config.timeoutDuration)
      globalConfig.value.timeoutDuration = Number.isFinite(duration) && duration > 0 ? duration : globalConfig.value.timeoutDuration
    }
  }

  return {
    globalConfig,
    embedEditorPresetType,
    embedEditorPreset,
    applyConfig,
  }
})
